import { Component, Input, Output, EventEmitter, ContentChild, ElementRef, AfterContentInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DEFAULT_MODALONE_CONFIG, ModalOneConfig } from './modal-one.modal';

@Component({
  selector: 'ds-modal-one',
  templateUrl: './modal-one.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class ModalOneComponent implements AfterContentInit {
  @Output() visibleChange = new EventEmitter<boolean>();


  public _modalOneInput: ModalOneConfig = { ...DEFAULT_MODALONE_CONFIG };
  @Input() modalOneInput!: ModalOneConfig;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.modalOneInput) {
      const val: ModalOneConfig = changes.modalOneInput.currentValue || {};
      this.modalOneInput = { ...DEFAULT_MODALONE_CONFIG, ...val };
    }
  }

  @ContentChild('[modal-header]', { read: ElementRef }) projectedHeader?: ElementRef;
  hasProjectedHeader = false;

  ngAfterContentInit(): void {
    this.hasProjectedHeader = !!this.projectedHeader;
  }

  close() {
    this.modalOneInput.visible = false;
    this.visibleChange.emit(false);
  }
}
